import React from "react";
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/LoginPage/login'
import { PATH } from "./libs/constants";
import MainPage from "./pages/MainPage";
import BrandDetails from "./pages/BrandDetailsPage/BrandDetailsPage";
import InvoiceProcessFeePage from "./pages/InvoiceDetailsPage/InvoiceProcessFeePage";
import InvoiceContentPage from "./pages/InvoiceDetailsPage/InvoiceContentPage";
import InvoiceOfficeWorkFeePage from "./pages/InvoiceDetailsPage/InvoiceOfficeWorkFeePage";
import InvoiceWrappingFeePage from "./pages/InvoiceDetailsPage/InvoiceWrappingFeePage";
import InvoiceLogisticFeePage from "./pages/InvoiceDetailsPage/InvoiceLogisticFeePage";
import InvoiceShippingFeePage from "./pages/InvoiceDetailsPage/InvoiceShippingFeePage";
import InvoiceArrivalInfoPage from "./pages/InvoiceDetailsPage/InvoiceArrivalInfoPage";


const App: React.FC = () => {
    return (
        <Routes>
            <Route path={PATH.login} element={<Login />}/>
            <Route path={PATH.brandDetails} element={<BrandDetails/>}/>
            <Route path={PATH.invoiceDetailProcess} element={<InvoiceProcessFeePage />}/>
            <Route path={PATH.invoiceDetailOfficeWork} element={<InvoiceOfficeWorkFeePage />}/>
            <Route path={PATH.invoiceDetailWrapping} element={<InvoiceWrappingFeePage />}/>
            <Route path={PATH.invoiceDetailLogistic} element={<InvoiceLogisticFeePage />}/>
            <Route path={PATH.invoiceDetailShipping} element={<InvoiceShippingFeePage />}/>
            <Route path={PATH.invoiceDetailArrival} element={<InvoiceArrivalInfoPage />}/>
            <Route path={PATH.invoiceDetails} element={<InvoiceContentPage />}/>
            <Route path={PATH.index} element={<MainPage/>}/>
            <Route path={"/"} element={<Navigate to="/dashboard" />}/>
            <Route path="*" element={<Navigate to="/dashboard" />}/>
        </Routes>
    )
};

export default App;